import Actions from './workspace-actions';
import mechanicTypes from './mechanic-types';
import Model from './workspace-model';
import reducer from './workspace-reducer';
import Selectors from './workspace-selectors';

export default {
  Actions,
  Api:       undefined,
  Enums:     { mechanicTypes },
  Model,
  namespace: 'workspace',
  reducer,
  sagas:     [],
  Selectors,
};
